var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var state;
(function (state_1) {
    function ok(state, result, index) {
        index || (index = state.index);
        return __assign(__assign({}, state), { result: result, index: index });
    }
    state_1.ok = ok;
    function error(state, error) {
        return __assign(__assign({}, state), { error: error, isError: true });
    }
    state_1.error = error;
})(state || (state = {}));
var _state = state.ok;
var _error = state.error;
function _extract(data) {
    if (!data || !data.length) {
        return [];
    }
    if (Array.isArray(data[0])) {
        return data[0];
    }
    return data;
}
/**
 * Create a parser out of a production function
 * @param handler the production function which can return a state or an error
 * @param error the function which will catch and elaborates errors produced by precedent operations
 * @returns a compiled perser
 */
export function parser(handler, error) {
    var out = typeof error === 'function'
        ? function (state) {
            return typeof state === 'string'
                ? handler({ source: state, index: 0, result: null, isError: false, error: null })
                : state.isError
                    ? error(state)
                    : handler(state);
        }
        : (function (state) {
            return typeof state === 'string'
                ? handler({ source: state, index: 0, result: null, isError: false, error: null })
                : state.isError
                    ? state
                    : handler(state);
        });
    out.map = function (fn) {
        return _parser(function (s) {
            var next = out(s);
            return next.isError ? next : _state(next, fn(next.result, next.index, next.source));
        });
    };
    out.error = function (fn) {
        return _parser(function (s) {
            var next = out(s);
            return next.isError ? _error(next, fn(next.error, next.index, next.source)) : s;
        });
    };
    out.chain = function (fn) {
        return _parser(function (s) {
            var next = out(s);
            return next.isError ? next : fn(next.result, next.index, next.source)(next);
        });
    };
    Object.defineProperty(out, 'isBinary', { value: false, enumerable: false, configurable: false, writable: false });
    return out;
}
var _parser = parser;
function _toBinary(value) {
    if (value instanceof DataView) {
        return value;
    }
    if (typeof value === 'string') {
        value = value.split('').map(function (s) { return s.charCodeAt(0); });
    }
    if (Array.isArray(value)) {
        value = new Uint8ClampedArray(value);
    }
    if (ArrayBuffer.isView(value)) {
        return new DataView(value.buffer, value.byteOffset, value.byteLength);
    }
    return new DataView(value);
}
function _isBinariable(value) {
    return typeof value === 'string' || ArrayBuffer.isView(value) || value instanceof ArrayBuffer || Array.isArray(value);
}
/**
 * Create a binary parser out of a production function
 * @param handler the production function which can return a binary state or an error
 * @param error the function which will catch and elaborates errors produced by precedent operations
 * @returns a compiled perser
 */
export function binary(handler, error) {
    var out = typeof error === 'function'
        ? function (state) {
            return _isBinariable(state)
                ? handler({ source: _toBinary(state), index: 0, result: null, isError: false, error: null })
                : state.isError
                    ? error(state)
                    : handler(state);
        }
        : (function (state) {
            return _isBinariable(state)
                ? handler({ source: _toBinary(state), index: 0, result: null, isError: false, error: null })
                : state.isError
                    ? state
                    : handler(state);
        });
    out.map = function (fn) {
        return _binary(function (s) {
            var next = out(s);
            return next.isError ? next : _state(next, fn(next.result, next.index, next.source));
        });
    };
    out.error = function (fn) {
        return _binary(function (s) {
            var next = out(s);
            return next.isError ? _error(next, fn(next.error, next.index, next.source)) : s;
        });
    };
    out.chain = function (fn) {
        return _binary(function (s) {
            var next = out(s);
            return next.isError ? next : fn(next.result, next.index, next.source)(next);
        });
    };
    Object.defineProperty(out, 'isBinary', { value: true, enumerable: false, configurable: false, writable: false });
    return out;
}
var _binary = binary;
var _matchStringIC = function (expression, state) {
    return state.source.slice(state.index, state.index + expression.length).toLowerCase() === expression
        ? _state(state, state.source.slice(state.index, state.index + expression.length), state.index + expression.length)
        : _error(state, "match: Tried to match '".concat(expression, "', but got '").concat(state.source.slice(state.index, state.index + expression.length), "' @ index ").concat(state.index));
};
var _matchStringNC = function (expression, state) {
    return state.source.slice(state.index, state.index + expression.length) === expression
        ? _state(state, expression, state.index + expression.length)
        : _error(state, "match: Tried to match '".concat(expression, "', but got '").concat(state.source.slice(state.index, state.index + expression.length), "' @ index ").concat(state.index));
};
var _matchRegexRaw = function (expression, state) {
    var match = state.source.slice(state.index).match(expression);
    return match
        ? _state(state, match[0], state.index + match[0].length)
        : _error(state, "match: Tried to match '".concat(expression, "', but got '").concat(state.source.slice(state.index, state.index + 20), "' @ index ").concat(state.index));
};
var _matchRegexMap = function (expression, map, state) {
    var match = state.source.slice(state.index).match(expression);
    return match
        ? _state(state, map(match), state.index + match[0].length)
        : _error(state, "match: Tried to match '".concat(expression, "', but got '").concat(state.source.slice(state.index, state.index + 20), "' @ index ").concat(state.index));
};
export function match(expression, matcher) {
    if (expression instanceof RegExp) {
        if (expression.source[0] !== '^') {
            expression = new RegExp('^' + expression.source, expression.ignoreCase ? 'i' : '');
        }
    }
    else {
        expression = String(expression);
    }
    return _parser(expression instanceof RegExp
        ? typeof matcher === 'function'
            ? _matchRegexMap.bind(null, expression, matcher)
            : _matchRegexRaw.bind(null, expression)
        : matcher
            ? _matchStringIC.bind(null, expression.toLowerCase())
            : _matchStringNC.bind(null, expression));
}
/** A parser which check for any letter in the range a-z (case insnsitive) */
export var letters = match(/^[A-Za-z]+/);
/** A parser which check for any digit in the range 0-9 */
export var digits = match(/^\d+/);
/** A parser which check for any white space */
export var spaces = match(/^\s+/);
/** A parser which check the end of the input */
export var eof = _parser(function (state) {
    return state.index >= state.source.length
        ? _state(state, null, state.index)
        : _error(state, "Expected End Of Input (eoi/eof/end) but found '".concat(state.source[state.index], "' @ index ").concat(state.index));
});
/** A parser which check the end of the input */
export var eoi = eof;
/** A parser which check the end of the input */
export var end = eof;
export function sequence() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    parsers = _extract(parsers);
    if (!parsers.length) {
        throw new TypeError('sequence: you must provide at least one parser');
    }
    return _parser(function (state) {
        var next = state;
        var results = [];
        for (var _i = 0, parsers_1 = parsers; _i < parsers_1.length; _i++) {
            var p = parsers_1[_i];
            next = p(next);
            if (next.isError) {
                return _error(state, next.error);
            }
            results.push(next.result);
        }
        return _state(next, results);
    });
}
export function oneOf() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    parsers = _extract(parsers);
    if (!parsers.length) {
        throw new TypeError('oneOf: you must provide at least one parser');
    }
    return _parser(function (state) {
        for (var _i = 0, parsers_2 = parsers; _i < parsers_2.length; _i++) {
            var p = parsers_2[_i];
            var next = p(state);
            if (!next.isError) {
                return next;
            }
        }
        return _error(state, "oneOf: Unable to match with any parser @ index ".concat(state.index));
    });
}
/**
 * Create a parser which tries to match the given parser
 * as many times as possible
 * @param parser the parser to test
 * @returns a parser which tries to match the given parser
 *              as many times as possible
 */
export function many(parser) {
    if (typeof parser !== 'function') {
        throw new TypeError('many: parser must be a valid parser function');
    }
    return _parser(function (state) {
        var next = state;
        var results = [];
        while (true) {
            var test_1 = parser(next);
            if (test_1.isError) {
                break;
            }
            results.push((next = test_1).result);
        }
        return _state(next, results);
    });
}
/**
 * Create a parser which match at least one time,
 * then as many times as possible, the given parser
 * @param parser the parser to test
 * @returns a parser which match at least one time,
 *          then as many times as possible, the given parser
 */
export function oneOrMore(parser) {
    if (typeof parser !== 'function') {
        throw new TypeError('oneOrMore: parser must be a valid parser function');
    }
    return _parser(function (state) {
        var next = state;
        var results = [];
        while (true) {
            var test_2 = parser(next);
            if (test_2.isError) {
                break;
            }
            results.push((next = test_2).result);
        }
        if (!results.length) {
            return _error(state, "oneOrMore: Unable to match any input parser @ index ".concat(state.index));
        }
        return _state(next, results);
    });
}
/**
 * Create a parser which match the given parser
 * the given number of times
 * @param parser the parser to test
 * @param times how many exact times the parser must match
 * @returns a parser which match the given parser
 *          the given number of times
 */
export function times(parser, times) {
    if (typeof parser !== 'function') {
        throw new TypeError('times: parser must be a valid parser function');
    }
    times = Number(times);
    if (isNaN(times)) {
        throw new TypeError('times: times argument must be a valid number');
    }
    if (times < 1) {
        throw new RangeError("times: times argument must be at least 1, ".concat(times, " given"));
    }
    return _parser(function (state) {
        var next = state;
        var results = [];
        for (var i = 0; i < times; ++i) {
            next = parser(next);
            if (next.isError) {
                return _error(state, "times: Unable to match the input parser ".concat(times, " times @ index ").concat(state.index));
            }
            results.push(next.result);
        }
        return _state(next, results);
    });
}
export function between(left, content, right) {
    return sequence(left, content, right || left).map(function (r) { return r[1]; });
}
export function parseBetween(left, right) {
    return function (content) { return between(left, content, right); };
}
/**
 * Generate a parser which tries to match one or more
 * times the following syntax: `(content separator)* content`.
 * The resultant parser will consider only the output of
 * the content parser.\
 * For example, to parse a comma-separated list you can use:
 * `separated(match(','), contentPasrer)`.
 * @param separator the parser that matches separator
 * @param content the parser that match the content
 * @returns a parser which generate a separated expression
 */
export function separated(separator, content) {
    return _parser(function (state) {
        var results = [];
        var next = state;
        while (true) {
            var test_3 = content(next);
            if (test_3.isError) {
                break;
            }
            results.push(test_3.result);
            next = test_3;
            var sep = separator(test_3);
            if (sep.isError) {
                break;
            }
            next = sep;
        }
        if (results.length === 0) {
            return _error(state, "separated: Unable to capture any results @ index ".concat(state.index));
        }
        return _state(next, results);
    });
}
/**
 * Generate an high-order function which creates a
 * separated expression for a parser. This function
 * returns another function which takes the content
 * parser as argument and generate a parser which will
 * match the following syntax: `(content separator)* content`.
 * The resultant parser will consider only the output of the
 * content parser.\
 * For example, to parse a comma-separated list you can use:
 * ```js
 * const contentParser = letters; // or whatever
 * const commaSeparated = parseSeparated(match(','));
 * const commaSeparatedParser = commaSeparated(contentParser);
 * ```
 * @param separator the parser that matches separator
 * @return an high-order function which generate a between parser expression
 */
export function parseSeparated(separator) {
    return function (content) { return separated(separator, content); };
}
/**
 * Generate a parser which will use the given thunk lazily.
 * This is helpful if you need to use parsers which depends one
 * on the other:
 * ```js
 * const parserA = lazy(() => sequence([ parserB, digits, parserB ]));
 * const parserB = lazy(() => oneOf([ parserA, digits, letters ]));
 * ```
 * @param thunk the lazy evaluated function which produce a parser
 * @param notCached wether to cache or not the output of the thunk (default: `false --> cached`)
 * @returns a parser which evaluates lazily the given thunk
 */
export function lazy(thunk, notCached) {
    if (notCached) {
        return _parser(function (state) { return thunk()(state); });
    }
    var res = null;
    return _parser(function (state) { return (res || (res = thunk()))(state); });
}
/**
 * Create a parser which always produces an error state
 * @param message the message of the error state
 * @returns a failure parser
 */
export function fail(message) {
    return _parser(function (state) { return _error(state, message); });
}
/**
 * Create a parser which always produces a success parser state
 * @param value the result value of the success state
 * @returns a success parser
 */
export function success(value) {
    return _parser(function (state) { return _state(state, value); });
}
/**
 * Create a parser which automatically chain the parsers produced
 * by a generator function, yielding their parserd results states.\
 * For example:
 * ```js
 * const declTypeParser = combo.oneOf(
 *  combo.match('VAR '),
 *  combo.match('GLOBAL_VAR ')
 * );
 * const typeParser = combo.oneOf(
 *  combo.match(' INT '),
 *  combo.match(' STRING '),
 *  combo.match(' BOOL ')
 * ).map(v => v.trim().toLowerCase());
 * const stringParser = combo.between(combo.match('"'), combo.letters);
 * const numParser = combo.digits.map(Number);
 * const boolParser = combo.oneOf(combo.match('true'), combo.match('false')).map(v => v === 'true');
 * const parser = combo.contextual(function*() { // Note that we use a generator function here
 *  const declarationType = yield declTypeParser; // yielding parser => returning 'var' | 'global_var'
 *  const varName = yield combo.letters; // returning string
 *  const type = yield typeParser; // returning 'int' | 'string' | 'bool'
 *  let data;
 *  switch (type) {
 *      case 'int': data = yield numParser; break;
 *      case 'string': data = yield stringParser; break;
 *      case 'bool': data = yield boolParser; break;
 *  }
 *  return { varName: varName, data, type: type.trim().toLowerCase(), declarationType: declarationType.trim().toLowerCase() };
 * });
 * parser('VAR theAnswer INT 42'); // { varName: 'theAnswer', data: 42, type: 'int', declarationType: 'var' }
 * parser('GLOBAL_VAR greeting STRING "Hello"'); // { varName: 'greetubg', data: 'Hello', type: 'string', declarationType: 'global_var' }
 * parser('VAR skyIsBlue BOOL true'); // { varName: 'skyIsBlue', data: true, type: 'bool', declarationType: 'var' }
 * ```
 * @param generator the function that generates the parsers to chain
 * @returns a automatically chained parser
 */
export function contextual(generator) {
    return success(null).chain(function () {
        var iterator = generator();
        function runStep(next) {
            var itResult = iterator.next(next);
            if (itResult.done) {
                return success(itResult.value);
            }
            var nextParser = itResult.value;
            if (typeof nextParser !== 'function') {
                throw new TypeError('contextual: yielded values must always be parsers!');
            }
            return nextParser.chain(runStep);
        }
        return runStep(undefined);
    });
}
(function (binary) {
    function _compare(left, right, leftOffset, rightOffset, leftLength, rightLength) {
        if (leftOffset === void 0) { leftOffset = 0; }
        if (rightOffset === void 0) { rightOffset = 0; }
        if (leftLength === void 0) { leftLength = -1; }
        if (rightLength === void 0) { rightLength = -1; }
        left = _toBinary(left);
        right = _toBinary(right);
        leftOffset = Math.max(Number(leftOffset) || 0, 0);
        rightOffset = Math.max(Number(rightOffset) || 0, 0);
        leftLength = leftLength < 0 ? left.byteLength : Math.min(leftLength, left.byteLength);
        rightLength = rightLength < 0 ? right.byteLength : Math.min(rightLength, right.byteLength);
        var maxOffset = rightLength - rightOffset;
        if (leftLength - leftOffset < maxOffset) {
            return false;
        }
        for (var i = 0; i < maxOffset; ++i) {
            if (left.getUint8(leftOffset + i) !== right.getUint8(rightOffset + i)) {
                return false;
            }
        }
        return true;
    }
    function _len(value) {
        if (typeof value === 'string' || Array.isArray(value)) {
            return value.length;
        }
        return value.byteLength;
    }
    function _hex(value, minDigits) {
        if (minDigits === void 0) { minDigits = 2; }
        var res = value.toString(16);
        while (res.length < minDigits) {
            res = '0' + res;
        }
        return res;
    }
    function _str(value, start, end) {
        if (typeof value === 'string') {
            return value.slice(start, end);
        }
        if (value instanceof ArrayBuffer ||
            (typeof SharedArrayBuffer !== 'undefined' && value instanceof SharedArrayBuffer)) {
            value = Array.prototype.slice.call(new Uint8Array(value));
        }
        else if (ArrayBuffer.isView(value)) {
            value = Array.prototype.slice.call(new Uint8Array(value.buffer, value.byteOffset, value.byteLength));
        }
        return ('<' +
            value
                .slice(start, end)
                .map(function (v) { return _hex(v); })
                .join(', ') +
            '>');
    }
    /**
     * Create a binary parser which check if the current state
     * starts with the given binary expression
     * @param expression the string expression to match
     * @param expressionOffset the offset where the considered expression starts
     * @param expressionLength the length of considered expression
     * @return a binary parser which check if the current state starts with the given bianry expression
     */
    function match(expression, expressionOffset, expressionLength) {
        if (expressionOffset === void 0) { expressionOffset = 0; }
        if (expressionLength === void 0) { expressionLength = -1; }
        expression = _toBinary(expression);
        return _binary(function (state) {
            return _compare(state.source, expression, state.index, expressionOffset, -1, expressionLength)
                ? _state(state, expression, state.index + expression.byteLength)
                : _error(state, "match: Tried to match '".concat(_str(expression), "', but got '").concat(_str(state.source, state.index, state.index + _len(expression)), "' @ index ").concat(state.index));
        });
    }
    binary.match = match;
    /** A binary parser which consumes a buffer bit by bit */
    binary.bit = _binary(function (state) {
        var byteOffset = Math.floor(state.index / 8);
        if (byteOffset >= state.source.byteLength) {
            return _error(state, "bit: Unexpected end of input @ index ".concat(state.index));
        }
        var byte = state.source.getUint8(byteOffset);
        var bitOffset = 7 - (state.index % 8);
        var res = byte & (1 << bitOffset) ? 1 : 0;
        return _state(state, res, state.index + 1);
    });
    /** A binary parser which consume a buffer bit by bit, expecting an unsetted bit (0) */
    binary.zero = _binary(function (state) {
        var byteOffset = Math.floor(state.index / 8);
        if (byteOffset >= state.source.byteLength) {
            return _error(state, "bit: Unexpected end of input @ index ".concat(state.index));
        }
        var byte = state.source.getUint8(byteOffset);
        var bitOffset = 7 - (state.index % 8);
        var res = byte & (1 << bitOffset) ? 1 : 0;
        return res
            ? _error(state, "zero: expected 0 but got 1 @ index ".concat(state.index))
            : _state(state, res, state.index + 1);
    });
    /** A binary parser which consume a buffer bit by bit, expecting a setted bit (1) */
    binary.one = _binary(function (state) {
        var byteOffset = Math.floor(state.index / 8);
        if (byteOffset >= state.source.byteLength) {
            return _error(state, "bit: Unexpected end of input @ index ".concat(state.index));
        }
        var byte = state.source.getUint8(byteOffset);
        var bitOffset = 7 - (state.index % 8);
        var res = byte & (1 << bitOffset) ? 1 : 0;
        return res
            ? _state(state, res, state.index + 1)
            : _error(state, "one: expected 1 but got 0 @ index ".concat(state.index));
    });
    /**
     * Create a binary parser which read an unsigned integer from
     * a fixed number of bits into a {@link Number}. The number of bits must not exceed
     * 32. For integers longer than 32 bits use {@link biguint}
     * @param bits the number of bits to read (1 <= bits <= 32)
     * @param bigEndian wether to read the number in Big Endian or Little Endian mode
     * @returns a binary parser which read an unsigned integer with the given specs
     */
    function uint(bits, bigEndian) {
        if (bits < 1) {
            throw new RangeError("uint: btis must be larger than 0, got ".concat(bits));
        }
        if (bits > 32) {
            throw new RangeError("uint: btis must be less or equal to 32, got ".concat(bits));
        }
        var seq = [];
        for (var i = 0; i < bits; ++i) {
            seq.push(binary.bit);
        }
        return sequence(seq).map(bigEndian
            ? function (bs) { return bs.reverse().reduce(function (a, b, i) { return a + (b << (bits - 1 - i)); }, 0); }
            : function (bs) { return bs.reduce(function (a, b, i) { return a + (b << (bits - 1 - i)); }, 0); });
    }
    binary.uint = uint;
    /** A binary parser which reads an unsigned 8-bit (1 byte) integer as {@link Number} */
    binary.uint8 = uint(8);
    /** A binary parser which reads an unsigned 8-bit (1 byte) integer as {@link Number}, Big Endian mode */
    binary.uint8BE = uint(8, true);
    /** A binary parser which reads an unsigned 16-bit (2 byte) integer as {@link Number} */
    binary.uint16 = uint(16);
    /** A binary parser which reads an unsigned 16-bit (2 byte) integer as {@link Number}, Big Endian mode */
    binary.uint16BE = uint(16, true);
    /** A binary parser which reads an unsigned 24-bit (3 byte) integer as {@link Number} */
    binary.uint24 = uint(24);
    /** A binary parser which reads an unsigned 24-bit (3 byte) integer as {@link Number}, Big Endian mode */
    binary.uint24BE = uint(24, true);
    /** A binary parser which reads an unsigned 32-bit (4 byte) integer as {@link Number} */
    binary.uint32 = uint(32);
    /** A binary parser which reads an unsigned 32-bit (4 byte) integer as {@link Number}, BigEndian mode */
    binary.uint32BE = uint(32, true);
    var _biZero = BigInt(0);
    var _biOne = BigInt(1);
    /**
     * Create a binary parser which read an unsigned integer from
     * a fixed number of bits into a {@link BigInt}. The number of
     * readable bits is limited by JS environment implementation.
     * @param bits the number of bits to read (bits >= 1)
     * @param bigEndian wether to read the number in Big Endian or Little Endian mode
     * @returns a binary parser which read an unsigned integer with the given specs
     */
    function biguint(bits, bigEndian) {
        if (bits < 1) {
            throw new RangeError("biguint: btis must be larger than 0, got ".concat(bits));
        }
        var seq = [];
        for (var i = 0; i < bits; ++i) {
            seq.push(binary.bit);
        }
        var _biBits = BigInt(bits - 1);
        return sequence(seq).map(bigEndian
            ? function (bs) { return bs.reverse().reduce(function (a, b, i) { return a + ((b ? _biOne : _biZero) << (_biBits - BigInt(i))); }, _biZero); }
            : function (bs) { return bs.reduce(function (a, b, i) { return a + ((b ? _biOne : _biZero) << (_biBits - BigInt(i))); }, _biZero); });
    }
    binary.biguint = biguint;
    /** A binary parser which reads an unsigned 64-bit (8 byte) integer as {@link BigInt} */
    binary.uint64 = biguint(64);
    /** A binary parser which reads an unsigned 64-bit (8 byte) integer as {@link BigInt}, Big Endian mode */
    binary.uint64BE = biguint(64, true);
    /** A binary parser which reads an unsigned 128-bit (16 byte) integer as {@link BigInt} */
    binary.uint128 = biguint(128);
    /** A binary parser which reads an unsigned 128-bit (16 byte) integer as {@link BigInt}, Big Endian mode */
    binary.uint128BE = biguint(128, true);
    /** A binary parser which reads an unsigned 256-bit (32 byte) integer as {@link BigInt} */
    binary.uint256 = biguint(256);
    /** A binary parser which reads an unsigned 256-bit (32 byte) integer as {@link BigInt}, Big Endian mode */
    binary.uint256BE = biguint(256, true);
    /**
     * Create a binary parser which read a signed integer from
     * a fixed number of bits into a {@link Number}. The number of bits must not exceed
     * 32. For integers longer than 32 bits use {@link bigint}
     * @param bits the number of bits to read (1 <= bits <= 32)
     * @param bigEndian wether to read the number in Big Endian or Little Endian mode
     * @returns a binary parser which read a signed integer with the given specs
     */
    function int(bits, bigEndian) {
        if (bits < 1) {
            throw new RangeError("int: btis must be larger than 0, got ".concat(bits));
        }
        if (bits > 32) {
            throw new RangeError("int: btis must be less or equal to 32, got ".concat(bits));
        }
        var seq = [];
        for (var i = 0; i < bits; ++i) {
            seq.push(binary.bit);
        }
        return sequence(seq).map(bigEndian
            ? function (bs) {
                return !(bs = bs.reverse())[0]
                    ? bs.reduce(function (a, b, i) { return a + (b << (bits - 1 - i)); }, 0)
                    : -(1 + bs.reduce(function (a, b, i) { return a + ((b ? 0 : 1) << (bits - 1 - i)); }, 0));
            }
            : function (bs) {
                return !bs[0]
                    ? bs.reduce(function (a, b, i) { return a + (b << (bits - 1 - i)); }, 0)
                    : -(1 + bs.reduce(function (a, b, i) { return a + ((b ? 0 : 1) << (bits - 1 - i)); }, 0));
            });
    }
    binary.int = int;
    /** A binary parser which reads a signed 8-bit (1 byte) integer as {@link Number} */
    binary.int8 = int(8);
    /** A binary parser which reads a signed 8-bit (1 byte) integer as {@link Number}, Big Endian mode */
    binary.int8BE = int(8, true);
    /** A binary parser which reads a signed 16-bit (2 byte) integer as {@link Number} */
    binary.int16 = int(16);
    /** A binary parser which reads a signed 16-bit (2 byte) integer as {@link Number}, Big Endian mode */
    binary.int16BE = int(16, true);
    /** A binary parser which reads a signed 24-bit (3 byte) integer as {@link Number} */
    binary.int24 = int(24);
    /** A binary parser which reads a signed 24-bit (3 byte) integer as {@link Number}, Big Endian mode */
    binary.int24BE = int(24, true);
    /** A binary parser which reads a signed 32-bit (4 byte) integer as {@link Number} */
    binary.int32 = int(32);
    /** A binary parser which reads a signed 32-bit (4 byte) integer as {@link Number}, Big Endian mode */
    binary.int32BE = int(32, true);
    /**
     * Create a binary parser which read a signed integer from
     * a fixed number of bits into a {@link BigInt}. The number of
     * readable bits is limited by JS environment implementation.
     * @param bits the number of bits to read (bits >= 1)
     * @param bigEndian wether to read the number in Big Endian or Little Endian mode
     * @returns a binary parser which read a signed integer with the given specs
     */
    function bigint(bits, bigEndian) {
        if (bits < 1) {
            throw new RangeError("bigint: btis must be larger than 0, got ".concat(bits));
        }
        var seq = [];
        for (var i = 0; i < bits; ++i) {
            seq.push(binary.bit);
        }
        var _biBits = BigInt(bits - 1);
        return sequence(seq).map(bigEndian
            ? function (bs) {
                return !(bs = bs.reverse())[0]
                    ? bs.reduce(function (a, b, i) { return a + ((b ? _biOne : _biZero) << (_biBits - BigInt(i))); }, _biZero)
                    : -(_biOne + bs.reduce(function (a, b, i) { return a + ((b ? _biZero : _biOne) << (_biBits - BigInt(i))); }, _biZero));
            }
            : function (bs) {
                return !bs[0]
                    ? bs.reduce(function (a, b, i) { return a + ((b ? _biOne : _biZero) << (_biBits - BigInt(i))); }, _biZero)
                    : -(_biOne + bs.reduce(function (a, b, i) { return a + ((b ? _biZero : _biOne) << (_biBits - BigInt(i))); }, _biZero));
            });
    }
    binary.bigint = bigint;
    /** A binary parser which reads an unsigned 64-bit (8 byte) integer as {@link BigInt} */
    binary.int64 = bigint(64);
    /** A binary parser which reads an unsigned 64-bit (8 byte) integer as {@link BigInt}, Big Endian mode */
    binary.int64BE = bigint(64, true);
    /** A binary parser which reads an unsigned 128-bit (16 byte) integer as {@link BigInt} */
    binary.int128 = bigint(128);
    /** A binary parser which reads an unsigned 128-bit (16 byte) integer as {@link BigInt}, Big Endian mode */
    binary.int128BE = bigint(128, true);
    /** A binary parser which reads an unsigned 256-bit (32 byte) integer as {@link BigInt} */
    binary.int256 = bigint(256);
    /** A binary parser which reads an unsigned 256-bit (32 byte) integer as {@link BigInt}, Big Endian mode */
    binary.int256BE = bigint(256, true);
    function sequence() {
        var parsers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parsers[_i] = arguments[_i];
        }
        parsers = _extract(parsers);
        if (!parsers.length) {
            throw new TypeError('sequence: you must provide at least one parser');
        }
        return _binary(function (state) {
            var next = state;
            var results = parsers.map(function (p) { return (next = p(next)).result; });
            return _state(next, results);
        });
    }
    binary.sequence = sequence;
    function oneOf() {
        var parsers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            parsers[_i] = arguments[_i];
        }
        parsers = _extract(parsers);
        if (!parsers.length) {
            throw new TypeError('oneOf: you must provide at least one parser');
        }
        return _binary(function (state) {
            for (var _i = 0, parsers_3 = parsers; _i < parsers_3.length; _i++) {
                var p = parsers_3[_i];
                var next = p(state);
                if (!next.isError) {
                    return next;
                }
            }
            return _error(state, "oneOf: Unable to match with any parser @ index ".concat(state.index));
        });
    }
    binary.oneOf = oneOf;
    /**
     * Create a binary parser which tries to match the given binary parser
     * as many times as possible
     * @param parser the binary parser to test
     * @returns a binary parser which tries to match the given binary parser
     *              as many times as possible
     */
    function many(parser) {
        if (typeof parser !== 'function') {
            throw new TypeError('many: parser must be a valid parser function');
        }
        return _binary(function (state) {
            var next = state;
            var results = [];
            while (true) {
                var test_4 = parser(next);
                if (test_4.isError) {
                    break;
                }
                results.push((next = test_4).result);
            }
            return _state(next, results);
        });
    }
    binary.many = many;
    /**
     * Create a binary parser which match at least one time,
     * then as many times as possible, the given binary parser
     * @param parser the binary parser to test
     * @returns a binary parser which match at least one time,
     *          then as many times as possible, the given binary parser
     */
    function oneOrMore(parser) {
        if (typeof parser !== 'function') {
            throw new TypeError('oneOrMore: parser must be a valid parser function');
        }
        return _binary(function (state) {
            var next = state;
            var results = [];
            while (true) {
                var test_5 = parser(next);
                if (test_5.isError) {
                    break;
                }
                results.push((next = test_5).result);
            }
            if (!results.length) {
                return _error(state, "oneOrMore: Unable to match any input parser @ index ".concat(state.index));
            }
            return _state(next, results);
        });
    }
    binary.oneOrMore = oneOrMore;
    /**
     * Create a binary parser which match the given binary parser
     * the given number of times
     * @param parser the binary parser to test
     * @param times how many exact times the binary parser must match
     * @returns a binary parser which match the given binary parser
     *          the given number of times
     */
    function times(parser, times) {
        if (typeof parser !== 'function') {
            throw new TypeError('many: parser must be a valid parser function');
        }
        times = Number(times);
        if (isNaN(times)) {
            throw new TypeError('times: times argument must be a valid number');
        }
        if (times < 1) {
            throw new RangeError("times: times argument must be at least 1, ".concat(times, " given"));
        }
        return _binary(function (state) {
            var next = state;
            var results = [];
            for (var i = 0; i < times; ++i) {
                next = parser(next);
                if (next.isError) {
                    return _error(state, "times: Unable to match the input parser ".concat(times, " times @ index ").concat(state.index));
                }
                results.push(next.result);
            }
            return _state(next, results);
        });
    }
    binary.times = times;
    function between(left, content, right) {
        return sequence(left, content, right || left).map(function (r) { return r[1]; });
    }
    binary.between = between;
    function parseBetween(left, right) {
        return function (content) { return between(left, content, right); };
    }
    binary.parseBetween = parseBetween;
    /**
     * Generate a binary parser which tries to match one or more
     * times the following syntax: `(content separator)* content`.
     * The resultant binary parser will consider only the output of
     * the content binary parser.\
     * For example, to a list separated by the sequence `000` you can use:
     * `separated(sequence(zero, zero, zero), contentPasrer)`.
     * @param separator the binary parser that matches separator
     * @param content the binary parser that match the content
     * @returns a binary parser which generate a separated expression
     */
    function separated(separator, content) {
        return _binary(function (state) {
            var results = [];
            var next = state;
            while (true) {
                var test_6 = content(next);
                if (test_6.isError) {
                    break;
                }
                results.push(test_6.result);
                next = test_6;
                var sep = separator(test_6);
                if (sep.isError) {
                    break;
                }
                next = sep;
            }
            if (results.length === 0) {
                return _error(state, "separated: Unable to capture any results @ index ".concat(state.index));
            }
            return _state(next, results);
        });
    }
    binary.separated = separated;
    /**
     * Generate an high-order function which creates a
     * separated expression for a binary parser. This function
     * returns another function which takes the content
     * binary parser as argument and generate a binary parser which will
     * match the following syntax: `(content separator)* content`.
     * The resultant binary parser will consider only the output of the
     * content binary parser.\
     * For example, to parse a list which elements are separated by `0` you can use:
     * ```js
     * const contentParser = uint8; // or whatever
     * const zeroSeparated = parseSeparated(zero);
     * const zeroSeparatedParser = zeroSeparated(contentParser);
     * ```
     * @param separator the binary parser that matches separator
     * @return an high-order function which generate a binary between parser expression
     */
    function parseSeparated(separator) {
        return function (content) { return separated(separator, content); };
    }
    binary.parseSeparated = parseSeparated;
    /**
     * Generate a binary parser which will use the given thunk lazily.
     * This is helpful if you need to use binary parsers which depends one
     * on the other:
     * ```js
     * const parserA = lazy(() => sequence(parserB, zero, zero, parserB));
     * const parserB = lazy(() => oneOf(parserA, sequence(zero, zero, one), sequence(one, one, zero)));
     * ```
     * @param thunk the lazy evaluated function which produce a binary parser
     * @param notCached wether to cache or not the output of the thunk (default: `false --> cached`)
     * @returns a binary parser which evaluates lazily the given thunk
     */
    function lazy(thunk, notCached) {
        if (notCached) {
            return _binary(function (state) { return thunk()(state); });
        }
        var res = null;
        return _binary(function (state) { return (res || (res = thunk()))(state); });
    }
    binary.lazy = lazy;
    /**
     * Create a binary parser which always produces an error state
     * @param message the message of the error state
     * @returns a failure binary parser
     */
    function fail(message) {
        return _binary(function (state) { return _error(state, message); });
    }
    binary.fail = fail;
    /**
     * Create a binary parser which always produces a success binary parser state
     * @param value the result value of the success state
     * @returns a success binary parser
     */
    function success(value) {
        return _binary(function (state) { return _state(state, value); });
    }
    binary.success = success;
    /**
     * Create a binary parser which automatically chain the binary parsers produced
     * by a generator function, yielding their parserd binary results states.\
     * See the non binary version of this function for a tip on the usage.
     * @param generator the function that generates the binary parsers to chain
     * @returns a automatically chained binary parser
     */
    function contextual(generator) {
        return success(null).chain(function () {
            var iterator = generator();
            function runStep(next) {
                var itResult = iterator.next(next);
                if (itResult.done) {
                    return success(itResult.value);
                }
                var nextParser = itResult.value;
                if (typeof nextParser !== 'function') {
                    throw new TypeError('contextual: yielded values must always be parsers!');
                }
                return nextParser.chain(runStep);
            }
            return runStep(undefined);
        });
    }
    binary.contextual = contextual;
    var _asBinaryRep = /\s+/g;
    /**
     * Utility function to convert a string or an array
     * into a buffer. Note that all non-zero characters
     * are considered as a one bit, as well as any non
     * truish numeric values (eg. `0, NaN`).
     * @param value the value to being converted
     * @returns the converted buffer as a {@link DataView}
     */
    function asBinary(value) {
        if (typeof value === 'string') {
            value = value
                .replace(_asBinaryRep, '')
                .split('')
                .map(function (v) { return v === '1'; });
        }
        var output = [];
        var len = Math.ceil(value.length / 8);
        for (var i = 0; i < len; ++i) {
            output[i] = 0;
            for (var j = 0; j < 8; ++j) {
                output[i] |= (Number(value[i * 8 + j]) ? 1 : 0) << (7 - j);
            }
        }
        var buf = new Uint8Array(output);
        return new DataView(buf.buffer);
    }
    binary.asBinary = asBinary;
    /**
     * Converts a string to a byte array buffer
     * @param value the string to convert
     * @returns the converted buffer as a {@link DataView}
     */
    function toCharCode(value) {
        return new DataView(new Uint8Array(value.split('').map(function (v) { return v.charCodeAt(0); })).buffer);
    }
    binary.toCharCode = toCharCode;
})(binary || (binary = {}));
export default {
    binary: binary,
    between: between,
    contextual: contextual,
    digits: digits,
    end: end,
    eof: eof,
    eoi: eoi,
    fail: fail,
    lazy: lazy,
    letters: letters,
    many: many,
    match: match,
    parseBetween: parseBetween,
    parseSeparated: parseSeparated,
    parser: parser,
    success: success,
    separated: separated,
    sequence: sequence,
    spaces: spaces,
    state: state,
    times: times,
    oneOf: oneOf,
    oneOrMore: oneOrMore,
};
